<template>
  <page>
    <div class="page-title">出入款管理</div>
    <div class="page-content" style="padding: 0">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="三方入款管理" name="payin">
          <ManagePayinChannelTab @update="handleUpdate" />
        </el-tab-pane>
        <el-tab-pane label="三方出款管理" name="payout">
          <ManagePayoutChannelTab @update="handleUpdate" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </page>
</template>

<script>
import ManagePayinChannelTab from './components/ManagePayinChannelTab.vue'
import ManagePayoutChannelTab from './components/ManagePayoutChannelTab.vue'

export default {
  name: 'AdminFinancePaymentChannelManage',
  components: {
    ManagePayinChannelTab,
    ManagePayoutChannelTab,
  },
  data() {
    return {
      activeTab: 'payin',
    }
  },
  methods: {
    handleUpdate() {},
  },
}
</script>

<style scoped>
.page-content {
  padding: 0;
}
.page-content :deep(.el-tabs__item) {
  padding: 0 20px !important;
}
</style>
